import styled from 'styled-components'

const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: bold;
  line-height: 1.7;
`

export default ModalTitle
